import { render, staticRenderFns } from "./DeliveryTime.vue?vue&type=template&id=498300e0&scoped=true&"
import script from "./DeliveryTime.vue?vue&type=script&lang=js&"
export * from "./DeliveryTime.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryTime.vue?vue&type=style&index=0&id=498300e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498300e0",
  null
  
)

export default component.exports